import { combineReducers } from 'redux'
import { reducer as categoryList } from './categoryList'
import { reducer as countryInfo } from './countryInfo'
import { reducer as countryList } from './countryList'
import { reducer as locale } from './locale'
import { reducer as pageList } from './pageList'
import { reducer as productAttributeList } from './productAttributeList'
import { reducer as storeConfig } from './storeConfig'

export const reducer = combineReducers({
  categoryList,
  countryInfo,
  countryList,
  locale,
  pageList,
  productAttributeList,
  storeConfig
})
